import notificationService from '@/services/notificationService';
import { Module } from 'vuex';
import { QuotationsClient } from '@/data/web-api-client';

const quotationsModule: Module<any, any> = {
    namespaced: true,
    state: {
        lists: [],
        initialised: false,
        loading: true,
    },
    getters: {
        lists: (state) => state.lists,
        loading: (state) => state.loading,
    },
    mutations: {
        setItems(state, objects) {
            state.initialised = true;
            state.lists = objects;
        },
        setLoading(state, value) {
            state.loading = value;
        },
        setSaving(state, value) {
            state.saving = value;
        },
    },
    actions: {
        async fetch({ commit, dispatch, state }, { axios }) {
            if (!state.initialised) {
                commit('setLoading', true);
                try {
                    const res = await new QuotationsClient(undefined, axios).getQuotationTypes();
                    commit('setItems', res);
                } catch (err) {
                    notificationService.failedToLoad();
                } finally {
                    commit('setLoading', false);
                }
            }
        },
    },
};

export default quotationsModule;
